module.exports = __webpack_public_path__ + "static/media/eek24.2cf3bacf.JPG";